import {
  COMPONENT_STATE_ARGS,
  INPUT_MENU_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import Menu from '../../../core/menu/base.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Base menu container for search input results',
  extends: [
    pick(MENU_ARGS, ['anchorElement']),
    pick(INPUT_MENU_ARGS, ['multiselect', 'noResultsText']),
    pick(COMPONENT_STATE_ARGS, [{ name: 'open', required: true }]),
  ],
  name: 'Search Menu Base',
});

export default class SpdsInputSearchMenuBase extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @id={{@id}}
      @open={{@open}}
      @multiselect={{@multiselect}}
      @noItemsDisplayed={{@noItemsDisplayed}}
      @noResultsText={{@noResultsText}}
      @searchable={{false}}
      class="spds-input-search-menu"
      data-test-spds-input-search-menu
      ...attributes
      {{this.validateArguments}}
    >
      {{yield}}
    </Menu>
  </template>
}

export const SEARCH_MENU_BASE_METADATA = SpdsInputSearchMenuBase.metadata;
